import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Tr} from "@/i18n/i18n";
import {SquareButton} from "@/scenes.ui/square-button";
import {Keys} from "@/constants/key";
import {PaymentChangeService} from "@/services/payment-change-service";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";

export class PaymentChangePanelBank extends Phaser.GameObjects.Container {

    public static HEIGHT = 80;

    private paymentChangeService: PaymentChangeService = new PaymentChangeService();

    constructor(scene: Phaser.Scene, onPaymentButtonPressCallback: () => unknown) {
        super(scene);

        this.scene = scene;
        this.height = PaymentChangePanelBank.HEIGHT;

        const back = SpriteUtils.addImage(this.scene, -300, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.height + 60);
        this.add(back);

        let descText = TextUtils.addTextAdvanced(scene, Tr('viberite.sposob.oplaty'), 0, this.height / 2 + 4,
            '#e2e2e2', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let button = SpriteUtils.scale(new SquareButton(this.scene, 230, this.height / 2 - 4, 0, Keys.UI_ART_PALE_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_PAYMENT_CHANGE, '', false, 84, 84, 0), 0.5);

        if (onPaymentButtonPressCallback != null) {
            button.setCallback(onPaymentButtonPressCallback);
        }


        const separator = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0.5);

        this.add([descText, button, separator]);
    }

}
